import { render, staticRenderFns } from "./signPage.vue?vue&type=template&id=3448817e&scoped=true"
import script from "./signPage.vue?vue&type=script&lang=js"
export * from "./signPage.vue?vue&type=script&lang=js"
import style0 from "./signPage.vue?vue&type=style&index=0&id=3448817e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448817e",
  null
  
)

export default component.exports